export default __webpack_public_path__ + "static/media/teaser-etalinepro-small.be6d434c.jpg";